<template>
    <div>
        <div v-if="loading.initial">Loading...</div>

        <div class="row row--sml flex-wrap text-sm" v-if="!loading.initial" v-masonry>
            <div class="col col--sml w-full sm:w-full md:w-1/2 lg:w-1/4 xl:w-1/4" v-for="(item, index) in items" v-masonry-tile>
                <div class="box box--p-0 box--overflow relative mb-6 shadow">
                    <span class="badge badge--right badge--pill badge--facebook">
                        <i class="fab fa-facebook-f"></i>
                    </span>
                    <div class="pr-8 pl-6 pt-12 pb-4">
                        <p>
                            <a :href="item.permalink_url" class="text-social no-underline font-bold" target="_blank">@BananaMoon</a>
                            {{ item.message }}
                        </p>
                        <p class="mb-0 text-grey-dark">
                            <small>
                                @BananaMoon - <span v-html="moment(item.created_time).fromNow()"></span>
                            </small>
                        </p>
                    </div>
                    <div class="social-image" v-if="typeof item.full_picture != 'undefined'">
                        <img :src="item.full_picture">
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4 md:mt-12" v-if="more">
            <div class="col w-full text-center">
                <a href="#" class="btn btn--lg btn--pill btn--bordered btn--bordered--grey-darker btn--transparent btn--text--grey-darker btn--hover--grey-darker btn--hover--text--white" @click="next">
                    <span v-if="!loading.state">Load more</span>
                    <span v-else>Loading...</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SocialFeedComponent',
    data: () => ({
        page: 0,
        items: [],
        more: false,
        loading: {
            initial: true,
            state: true
        }
    }),

    async created() {
        await this.get();

        this.loading.initial = false;
    },

    methods: {
        async get() {
            this.loading.state = true;

            BananaMoon.request().post('/ajax/social', {
                page: this.page
            })
            .catch(error => {
            })
            .then(response => {
                if(typeof response.data.items != 'undefined') {
                    for(let key in response.data.items) {
                        this.items.push(response.data.items[key]);
                    }
                }

                if(typeof response.data.more != 'undefined') {
                    this.more = response.data.more;
                } else this.more = false;

                this.$nextTick(() => {
                    this.loading.state = false;
                })
            });
        },
        next() {
            if(this.loading.state) return;

            this.page++;
            this.get();
        }
    }
}
</script>



// WEBPACK FOOTER //
// SocialFeed.vue?744fd689